'use client';

import React from 'react';
import Modal from './Modal';
import Button from './Button';

interface ConfirmDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    variant?: 'danger' | 'default';
    isLoading?: boolean;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    variant = 'default',
    isLoading,
}) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={isLoading ? () => { } : onClose}
            title={title}
            maxWidth="sm"
        >
            <div className="space-y-4">
                <p className="text-gray-600">
                    {message}
                </p>
                <div className="flex justify-end gap-3 pt-4">
                    <Button
                        variant="ghost"
                        onClick={onClose}
                        className="text-gray-600 hover:text-gray-800"
                        disabled={isLoading}
                    >
                        {cancelText}
                    </Button>
                    <Button
                        variant={variant === 'danger' ? 'destructive' : 'primary'}
                        onClick={() => {
                            onConfirm();
                            // If isLoading is provided (even if false), we assume the parent handles closing
                            // otherwise we auto-close for convenience
                            if (typeof isLoading === 'undefined') {
                                onClose();
                            }
                        }}
                        isLoading={isLoading}
                        disabled={isLoading}
                    >
                        {confirmText}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default ConfirmDialog;
